import moment from "moment";
import { DATE_FORMAT } from "../settings";

export default function formatDate(timestamp: number): string {
    return moment.unix(timestamp).format(DATE_FORMAT);
}



// WEBPACK FOOTER //
// ./src/utils/formatDate.ts